// extracted by mini-css-extract-plugin
module.exports = {"analyticsMain":"AnalyticsMain_analyticsMain__2-Avt"};